module.exports = __webpack_public_path__ + "static/img/bt.552a870b.svg";